export default __webpack_public_path__ + "static/media/org-insights-demographics.8bd3f402.png";